<template>
  <div>
    <Layout/>
    <h4>Empresas</h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idEmpresa" class="form-label">IdEmpresa</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idEmpresa" name="idEmpresa" v-model="datoEmpresa.idEmpresa" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idLocalidad" name="idLocalidad" v-model="datoEmpresa.idLocalidad"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idLocalidad" class="form-label"> Localidad</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="localidad" name="localidad" v-model="datoEmpresa.localidad" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalLocalidadLOV"
                      title="Buscar Localidades">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idTipoIden" name="idTipoIden" v-model="datoEmpresa.idTipoIden"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idTipoIden" class="form-label"> Tipo Iden</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="tipoIden" name="tipoIden" v-model="datoEmpresa.tipoIden" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalTipoIdenLOV"
                      title="Buscar Tipos de Identificación">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="documento" class="form-label">Documento</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="documento" name="documento" v-model="datoEmpresa.documento" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="razonSocial" class="form-label">RazonSocial</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="razonSocial" name="razonSocial" v-model="datoEmpresa.razonSocial" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="nombre" name="nombre" v-model="datoEmpresa.nombre" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombreCorto" class="form-label">NombreCorto</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="nombreCorto" name="nombreCorto" v-model="datoEmpresa.nombreCorto" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="direccion" class="form-label">Dirección</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="direccion" name="direccion" v-model="datoEmpresa.direccion" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaReg" name="fechaReg" v-model="datoEmpresa.fechaReg" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaAct" class="form-label">FechaAct</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaAct" name="fechaAct" v-model="datoEmpresa.fechaAct" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idUsuarioReg" class="form-label">IdUsuarioReg</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idUsuarioReg" name="idUsuarioReg" v-model="datoEmpresa.idUsuarioReg" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idUsuarioAct" class="form-label">IdUsuarioAct</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idUsuarioAct" name="idUsuarioAct" v-model="datoEmpresa.idUsuarioAct" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" @click.prevent="cerrarEmpresa" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEmpresa" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditEmpresa" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdCita</th>
          <th scope="col">IdEmpresa</th>
          <th scope="col">IdPersona</th>
          <th scope="col">IdHorario</th>
          <th scope="col">IdUsuarioReg</th>
          <th scope="col">IdUsuarioAct</th>
          <th scope="col">IdMedico</th>
          <th scope="col">FechaReg</th>
          <th scope="col">FechaAct</th>
          <th scope="col">FechaCita</th>
          <th scope="col">Hora Desde</th>
          <th scope="col">Hora Hasta</th>
          <th scope="col">EstadoCita</th>
          <th scope="col">Descripción</th>
          <th scope="col">Observación</th>
          <th scope="col">Estado</th>
          <th scope="col">EmpresaNombre</th>
          <th scope="col">PersonaFechaReg</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="cita in datosPaginados" :key="cita.idCita">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(cita.idCita)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(cita.idCita)" title="Editar">edit_square</i></td>
          <td>{{cita.idCita}}</td>
          <td>{{cita.idEmpresa}}</td>
          <td>{{cita.idPersona}}</td>
          <td>{{cita.idHorario}}</td>
          <td>{{cita.idUsuarioReg}}</td>
          <td>{{cita.idUsuarioAct}}</td>
          <td>{{cita.idMedico}}</td>
          <td>{{getFormattedDate(cita.fechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{getFormattedDate(cita.fechaAct, 'DD/MM/YYYY')}}</td>
          <td>{{getFormattedDate(cita.fechaCita, 'DD/MM/YYYY')}}</td>
          <td>{{cita.horaDesde}}</td>
          <td>{{cita.horaHasta}}</td>
          <td>{{cita.estadoCita}}</td>
          <td>{{cita.descripcion}}</td>
          <td>{{cita.observacion}}</td>
          <td>{{cita.estado}}</td>
          <td>{{cita.empresaNombre}}</td>
          <td>{{getFormattedDate(cita.personaFechaReg, 'DD/MM/YYYY')}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteEmpresa(cita.idCita)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idCita" class="form-label">IdCita</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idCita" name="idCita" v-model="datoCita.idCita" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idEmpresa" class="form-label">IdEmpresa</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idEmpresa" name="idEmpresa" v-model="datoCita.idEmpresa" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idPersona" name="idPersona" v-model="datoCita.idPersona"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idPersona" class="form-label"> Persona</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="persona" name="persona" v-model="datoCita.persona" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalPersonaLOV"
                      title="Buscar Personas">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idHorario" name="idHorario" v-model="datoCita.idHorario"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idHorario" class="form-label"> Horario</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="horario" name="horario" v-model="datoCita.horario" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalHorarioLOV"
                      title="Buscar Horarios">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idUsuarioReg" class="form-label">IdUsuarioReg</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idUsuarioReg" name="idUsuarioReg" v-model="datoCita.idUsuarioReg" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idUsuarioAct" class="form-label">IdUsuarioAct</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idUsuarioAct" name="idUsuarioAct" v-model="datoCita.idUsuarioAct" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idMedico" name="idMedico" v-model="datoCita.idMedico"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idMedico" class="form-label"> Medico</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="medico" name="medico" v-model="datoCita.medico" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalMedicoLOV"
                      title="Buscar Médico">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idEspecialidad" name="idEspecialidad" v-model="datoCita.idEspecialidad"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idEspecialidad" class="form-label"> Especialidad</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="especialidad" name="especialidad" v-model="datoCita.especialidad" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalEspecialidadLOV"
                      title="Buscar Especialidad">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaReg" name="fechaReg" v-model="datoCita.fechaReg" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaAct" class="form-label">FechaAct</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaAct" name="fechaAct" v-model="datoCita.fechaAct" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaCita" class="form-label">FechaCita</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaCita" name="fechaCita" v-model="datoCita.fechaCita" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="horaDesde" class="form-label">HoraDesde</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="horaDesde" name="horaDesde" v-model="datoCita.horaDesde" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="horaHasta" class="form-label">HoraHasta</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="horaHasta" name="horaHasta" v-model="datoCita.horaHasta" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="estadoCita" class="form-label">EstadoCita</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="estadoCita" name="estadoCita" v-model="datoCita.estadoCita" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="descripcion" class="form-label">Descripción</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="descripcion" name="descripcion" v-model="datoCita.descripcion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="observacion" class="form-label">Observación</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="observacion" name="observacion" v-model="datoCita.observacion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarCita" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditCita" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

<!--
Listas de valores master
-->
<!-- Lista de Valores: Localidad -->
    <LocalidadLOV @DatosLocalidad="GetDataLocalidadLOV($event)"/>
<!-- Lista de Valores: TipoIden -->
    <TipoIdenLOV @DatosTipoIden="GetDataTipoIdenLOV($event)"/>
<!--
Listas de valores master
-->
<!--
Listas de valores details
-->
<!-- Lista de Valores: Cita -->
    <CitaLOVdet @DatosCita="GetDataCitaLOVdet($event)"/>
<!-- Lista de Valores: Persona -->
    <PersonaLOVdet @DatosPersona="GetDataPersonaLOVdet($event)"/>
<!-- Lista de Valores: Horario -->
    <HorarioLOVdet @DatosHorario="GetDataHorarioLOVdet($event)"/>
<!-- Lista de Valores: Medico -->
    <MedicoLOVdet @DatosMedico="GetDataMedicoLOVdet($event)"/>
<!-- Lista de Valores: Especialidad -->
    <EspecialidadLOVdet @DatosEspecialidad="GetDataEspecialidadLOVdet($event)"/>
<!--
Listas de valores details
-->
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import dateFormat from '@/modules/dateFormat.js';
// Listas de valores master
import LocalidadLOV from '../../components/lovs/LocalidadLOV.vue'
import TipoIdenLOV from '../../components/lovs/TipoIdenLOV.vue'
// Listas de valores master
// Listas de valores details
import CitaLOVdet from '../../components/lovs/CitaLOV.vue'
import PersonaLOVdet from '../../components/lovs/PersonaLOV.vue'
import HorarioLOVdet from '../../components/lovs/HorarioLOV.vue'
import MedicoLOVdet from '../../components/lovs/MedicoLOV.vue'
import EspecialidadLOVdet from '../../components/lovs/EspecialidadLOV.vue'
// Listas de valores details
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
// Listas de valores master
, LocalidadLOV
, TipoIdenLOV
// Listas de valores master
// Listas de valores details
, CitaLOVdet
, PersonaLOVdet
, HorarioLOVdet
, MedicoLOVdet
, EspecialidadLOVdet
// Listas de valores details
  },
  data () {
    return {
// Variables master
      empresas : [],
      datoEmpresa : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idEmpresa: '',
// Variables master
// Variables details
      citas : [],
      datoCita : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idEmpresa = this.$route.params.p_idempresa
    this.abrirEditar(this.p_idEmpresa)
    this.getCitas()
    this.getDataPagina(this.paginaActual)
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
// Procedimientos master
    validarForm(){
      if(this.datoEmpresa.idEmpresa === ''){
        swal("Error!", "El elemento idEmpresa no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoEmpresa.idLocalidad === ''){
        swal("Error!", "El elemento idLocalidad no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoEmpresa.idTipoIden === ''){
        swal("Error!", "El elemento idTipoIden no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoEmpresa.documento === ''){
        swal("Error!", "El elemento documento no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoEmpresa.razonSocial === ''){
        swal("Error!", "El elemento razonSocial no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoEmpresa.nombre === ''){
        swal("Error!", "El elemento nombre no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoEmpresa.nombreCorto === ''){
        swal("Error!", "El elemento nombreCorto no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoEmpresa.direccion === ''){
        swal("Error!", "El elemento direccion no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoEmpresa.fechaReg === ''){
        swal("Error!", "El elemento fechaReg no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoEmpresa.fechaAct === ''){
        swal("Error!", "El elemento fechaAct no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoEmpresa.idUsuarioReg === ''){
        swal("Error!", "El elemento idUsuarioReg no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoEmpresa.idUsuarioAct === ''){
        swal("Error!", "El elemento idUsuarioAct no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoEmpresa.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarEmpresa(){
      if(this.validarForm() === 1){
        try {
          this.datoEmpresa.idEmpresa = window.sessionStorage.getItem("idEmpresa");
          await api.post('/empresas', this.datoEmpresa)
          swal("Correcto!", "Empresa creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditEmpresa(){
      if(this.validarForm() === 1){
        try {
          await api.post('/empresas', this.datoEmpresa)
          swal("Correcto!", "Empresa creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoEmpresa={}
      this.titulo   = 'Crear Empresas'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idEmpresa){
      this.modalWindow = true
      if(idEmpresa != null){    
           api.get('/vwempresas/'+idEmpresa).then(resp=>{
          this.datoEmpresa = resp.data;
           });
      }
      this.titulo   = 'Editar Empresas'
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarEmpresa(){
      this.$router.push('/Empresa')
    },
// Procedimientos master
// Procedimientos detalle
    async getCitas() {
      const resp = await api.get('/citas')
      this.citas = resp.data
    },
    totalPaginas(){
      return Math.ceil(this.citas.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwcitas/nombre/'+this.nombreBusqueda).then(response=>{
          this.citas=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.citas.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwcitas').then(response=>{
      this.citas=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.citas.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      if(this.datoCita.idEmpresa === ''){
        swal("Error!", "El elemento idEmpresa no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoCita.idLocalidad === ''){
        swal("Error!", "El elemento idLocalidad no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoCita.idTipoIden === ''){
        swal("Error!", "El elemento idTipoIden no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoCita.documento === ''){
        swal("Error!", "El elemento documento no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoCita.razonSocial === ''){
        swal("Error!", "El elemento razonSocial no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoCita.nombre === ''){
        swal("Error!", "El elemento nombre no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoCita.nombreCorto === ''){
        swal("Error!", "El elemento nombreCorto no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoCita.direccion === ''){
        swal("Error!", "El elemento direccion no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoCita.fechaReg === ''){
        swal("Error!", "El elemento fechaReg no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoCita.fechaAct === ''){
        swal("Error!", "El elemento fechaAct no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoCita.idUsuarioReg === ''){
        swal("Error!", "El elemento idUsuarioReg no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoCita.idUsuarioAct === ''){
        swal("Error!", "El elemento idUsuarioAct no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoCita.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarCita(){
      if(this.validarForm() === 1){
        try {
          this.datoCita.idEmpresa = this.datoEmpresa.idEmpresa;
          await api.post('/citas', this.datoCita)
          this.getCitas();
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "Cita creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditCita(){
      if(this.validarForm() === 1){
        try {
          await api.post('/citas', this.datoCita)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "Cita creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoCita={}
      this.titulo   = 'Crear Empresas'
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idCita){
      this.modalWindow = true
      if(idCita != null){    
           api.get('/vwcitas/'+idCita).then(resp=>{
          this.datoCita = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Empresas'
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idCita){
      this.modalWindow = true
      if(idCita != null){
        this.$router.push('/citamd/'+idCita)
      }
    },
    async deleteCita (idCita) {
      try{
        await api.delete('/citas/'+idCita)
          this.getCitas()
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
// Listas de valores master
//    Lista de Valores
    GetDataLocalidadLOV(data) {
      this.datoEmpresa.idLocalidad = data.idLocalidad;
      this.datoEmpresa.localidad = data.nombre;
    },
//    Lista de Valores
    GetDataTipoIdenLOV(data) {
      this.datoEmpresa.idTipoIden = data.idTipoIden;
      this.datoEmpresa.tipoIden = data.nombre;
    },
// Listas de valores master
// Listas de valores details
//    Lista de Valores
    GetDataCitaLOVdet(data) {
      this.datoCita.idCita = data.idCita;
      this.datoCita.cita = data.nombre;
    },
//    Lista de Valores
    GetDataPersonaLOVdet(data) {
      this.datoCita.idPersona = data.idPersona;
      this.datoCita.persona = data.nombre;
    },
//    Lista de Valores
    GetDataHorarioLOVdet(data) {
      this.datoCita.idHorario = data.idHorario;
      this.datoCita.horario = data.nombre;
    },
//    Lista de Valores
    GetDataMedicoLOVdet(data) {
      this.datoCita.idMedico = data.idMedico;
      this.datoCita.medico = data.nombre;
    },
//    Lista de Valores
    GetDataEspecialidadLOVdet(data) {
      this.datoCita.idEspecialidad = data.idEspecialidad;
      this.datoCita.especialidad = data.nombre;
    },
// Listas de valores details
  },
}
</script>
